export interface ComparisonRow {
  criterio: string;
  hoobuy: string;
  concorrente: string;
}

export const comparisonData: ComparisonRow[] = [
  { criterio: "Preço", hoobuy: "Mais Barato", concorrente: "Médio" },
  { criterio: "Facilidade", hoobuy: "Alta", concorrente: "Média" },
  { criterio: "Velocidade", hoobuy: "Alta", concorrente: "Média" },
  { criterio: "Segurança", hoobuy: "Alta", concorrente: "Alta" },
];

export const comparisonAgentesData: ComparisonRow[] = [
  { criterio: "Transparência", hoobuy: "Alta", concorrente: "Baixa" },
  { criterio: "Preço Final", hoobuy: "Baixo", concorrente: "Alto" },
  { criterio: "Organização", hoobuy: "Spreadsheet", concorrente: "Manual" },
  { criterio: "Taxas Ocultas", hoobuy: "Zero", concorrente: "Frequentes" },
];